import { curry, compose } from 'rich-text-lib/utils/iterables';

//Begin token single qoute escaping approach
//
// We need to insert a literal escape character in the case
// of a single qoute in the default value of a personalization token.
// This is the result of a limitation / condition of the backend ...
// see https://hubspot.slack.com/archives/C5GRAFS4A/p1583180373051600
// Because we only want to insert this once we want to use a "negative look behind"
// regex approach. However because JS does not support that strategy, we revers the
// string and use a negative lookahead finlly reversing the string again.
const stringReverse = string => string.split('').reverse().join('');
const fpReplaceAll = curry((match, value, string) => string.replaceAll(match, value));
export const escapeUnescapedSingleQuote = compose(stringReverse, fpReplaceAll(/'(?!\\)/g, "'\\"), stringReverse);
export const unescapeEscapedSingleQuote = compose(stringReverse, fpReplaceAll(/'\\/g, "'"), stringReverse);